var render = function render(){var _vm=this,_c=_vm._self._c;return _c('mdb-footer',[_c('p',{staticClass:"footer-copyright mb-0 py-3 text-center"},[_vm._v(" © "+_vm._s(new Date().getFullYear())+" Copyright: "),_c('a',{attrs:{"href":"https://www.virabeli.fi"}},[_vm._v(" virabeli.fi ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }